import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ArrowRight, Calendar } from 'lucide-react';
import { alumni } from '../mock';

// Featured slugs cycled monthly — deterministic per month, same rotation formula as gallery
const SPOTLIGHT_SLUGS = ['nick-scott', 'paul-hammond', 'bryquice-brown', 'jamari-venter'];

function currentSpotlight() {
  const now = new Date();
  const monthIdx = now.getUTCFullYear() * 12 + now.getUTCMonth();
  const slug = SPOTLIGHT_SLUGS[monthIdx % SPOTLIGHT_SLUGS.length];
  return alumni.find((a) => a.slug === slug) || alumni[0];
}

function nextRotationLabel() {
  const now = new Date();
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  const next = new Date(Date.UTC(m === 11 ? y + 1 : y, (m + 1) % 12, 1));
  return next.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export default function AlumniSpotlight() {
  const alum = currentSpotlight();
  if (!alum) return null;
  const rotate = nextRotationLabel();

  return (
    <section className="py-16 bg-white border-b border-[#0a1f44]/10" data-testid="alumni-spotlight">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-3 mb-6">
          <Star className="w-5 h-5 text-[#c8102e] fill-current" />
          <div className="font-heading uppercase tracking-[0.3em] text-[#c8102e] text-xs">BJP Alumni of the Month</div>
          <span className="ml-auto inline-flex items-center gap-1 font-heading uppercase tracking-widest text-[10px] text-[#0a1f44]/50">
            <Calendar className="w-3 h-3" /> Rotates {rotate}
          </span>
        </div>

        <Link
          to="/alumni"
          data-testid="alumni-spotlight-card"
          className="group grid md:grid-cols-[280px_1fr] gap-0 bg-[#0a1f44] shadow-2xl overflow-hidden hover-lift"
        >
          <div className="relative aspect-[3/4] md:aspect-auto overflow-hidden bg-[#0a1f44]">
            <img
              src={alum.img}
              alt={alum.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              style={alum.imgTransform ? { transform: alum.imgTransform, transformOrigin: '50% 50%' } : undefined}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-[#0a1f44]/40 md:to-transparent" />
            <div className="absolute top-3 left-3 bg-[#c8102e] text-white font-heading uppercase tracking-widest text-[10px] px-3 py-1">
              {alum.year}
            </div>
          </div>

          <div className="p-8 md:p-10 flex flex-col justify-center text-white">
            <div className="font-heading uppercase tracking-[0.3em] text-[#c8102e] text-[10px] mb-2">{alum.position}</div>
            <h3 className="font-display text-4xl md:text-5xl leading-tight mb-3">{alum.name.toUpperCase()}</h3>
            <div className="font-heading uppercase tracking-widest text-xs text-white/60 mb-4">
              {alum.school}
            </div>
            {alum.quote && (
              <blockquote className="text-white/90 text-lg leading-relaxed italic mb-6">
                "{alum.quote.replace(/^["']|["']$/g, '')}"
              </blockquote>
            )}
            <div className="inline-flex items-center gap-2 font-heading uppercase tracking-widest text-xs text-[#c8102e] group-hover:text-white transition-colors">
              Meet the Full Roster of BJP Alumni <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}
